
class Component {
    constructor(element) {
        this.config = JSON.parse(element.getAttribute('data-paypal'));
        this.button = element.querySelector('[data-paypal-button]');
        this.mainContainer = element.querySelector('[data-paypal-main]');
        this.okContainer = element.querySelector('[data-paypal-ok]');
        this.errorContainer = element.querySelector('[data-paypal-error]');
        this.paypal = window.paypal;

        this.initPaypal();
    }

    initPaypal() {
        this.paypal.Button.render({
            env: this.config.env, // production, sandbox

            client: this.getClient(),

            locale: this.getLocale(),

            style: {
                color: 'gold',  // gold, blue, silver, black
                shape: 'rect',  // pill, rect
                size: 'medium', // small, medium, large, responsive
                label: 'pay',   // checkout, credit, pay, buynow, paypal
                tagline: false,
            },

            // Show a 'Pay Now' button
            commit: true, 
    
            // This method is called when the user click on the Pay Now button
            // Here we tell the server to prepare the payment and to return the PaymentID
            payment: () => {
                this.reset();
        
                // Make a call to your server to set up the payment
                return this.paypal.request.post('/order/paypal-create').then((res) => {
                    if (res.status == 'ok') {
                        return res.paymentID;
                    } else {
                        this.error();
                    }
                });
            },

            // As the payment is authorized send the data back to our server so that
            // it executes the payment via REST API
            onAuthorize: (data) => {
                data = {
                    paymentID: data.paymentID,
                    payerID:   data.payerID,
                };
        
                return this.paypal.request.post('/order/paypal-execute', data).then((res) => {
                    if (res.status == 'ok') {
                        this.paymentAuthorized();
                    } else {
                        this.error();
                    }
                });
            },

            onError: () => {
                this.error();
            },
        }, '[data-paypal-button]');
    }

    getClient() {
        let client = {};
        client[this.config.env] = this.config.clientID;

        return client;
    }

    getLocale() {
        let localeParts = this.config.locale.split(/[-_]/g);
        let locale = [localeParts[0].toLowerCase()];

        if (localeParts.length > 1) {
            locale.push(localeParts[1].toUpperCase());
        }

        return locale.join('_');
    }

    reset() {
        this.errorContainer.style.display = 'none';
    }

    error() {
        this.errorContainer.style.display = '';
    }

    paymentAuthorized() {
        this.mainContainer.style.display = 'none';
        this.okContainer.style.display = '';
    }
}

const enhanceElement = (element) =>
    element ? new Component(element) : false;

const enhance = () =>
    enhanceElement(document.querySelector('[data-paypal]'));

export default {enhance};
    